<!-- <style>
	.pagination ::ng-deep .ngx-pagination .current {
		background: #e65100;
	}
</style> -->
<h1 class="page-header"><i class="fa fa-check-square-o" aria-hidden="true"></i>RULES</h1>
<div class="container-fluid">

	<div class="tab-content">
	<!-- ADD Button - Used to add new Rule -->
	<div class="page-button">
		<button (click)="addClicked()" class="btn btn-ef" type="button"><i class="fa fa-plus" aria-hidden="true"></i>
			ADD NEW</button>
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"><i
					class="fa fa-wrench"></i> ACTIONS <span class="caret"></span></button>
			<ul class="dropdown-menu">
				<li (click)="onAddGroups()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-plus"></em> ADD TO
						GROUP</a></li>
				<li (click)="onRemoveGroup()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-remove"></em>
						REMOVE FROM GROUP</a></li>
				<li (click)="onManageGroups()"><a><em class="fa fa-pencil"></em> MANAGE GROUPS</a></li>
			</ul>
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li (click)="setFilterRule(null, null)"><a>REMOVE FILTER</a></li>
				<li (click)="setFilterRule('Name', 'name')"><a>Name</a></li>
			</ul>
		</div>
		<div *ngIf="filterColumnRule != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameRule }}
		</div>
		<div *ngIf="filterColumnRule != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringRule" (ngModelChange)="filterStringChangedRule()">
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em class="fa fa-bars"></em> RESULTS
				PER PAGE <span class="caret"></span></button>
			<ul class="dropdown-menu">
				<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForRules(value)"
					[class.active]="value === selectedPageSizeValueForRules">
					<a>{{ value }}</a>
				</li>
			</ul>
		</div>

	</div>

	<!-- Rules -->
	<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
		role="grid">
		<thead>
			<tr role="row" class="tablesorter-headerRow">
				<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0"
					scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label=": No sort applied, activate to apply an ascending sort"
					style="user-select: none; width: 20px">
					<div class="tablesorter-header-inner">
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
								[checked]="isAllSelected()" (change)="selectAll($event)"><label for="checkbox"></label>
						</div>
					</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
					aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">NAME</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
					aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Name: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">CREATION DATE</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Groups: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">TRIGGER</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Groups: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">ACTIVE</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Groups: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">Groups</div>
				</th>
				<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
					data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
					role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
					aria-label="Groups: No sort applied, activate to apply an ascending sort">
					<div class="tablesorter-header-inner">&nbsp;</div>
				</th>
			</tr>
		</thead>
		<tbody aria-live="polite" aria-relevant="all">
			<ng-container
				*ngFor="let ruleUI of selectedRules | paginate: {id: 'rule_pagination', itemsPerPage: selectedPageSizeValueForRules, currentPage: currentPageForRules, totalItems: totalNumberOfRules }">
				<tr>
					<td>
						<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
								[(ngModel)]="ruleUI.selected"><label for="checkbox"></label></div>
					</td>
					<td (click)="editRule(ruleUI.rule)">{{ruleUI.rule.name}}</td>
					<td (click)="editRule(ruleUI.rule)">{{ruleUI.rule.creationDate | date:"M/d/yyyy h:mm a" }}</td>
					<td (click)="editRule(ruleUI.rule)">{{ruleUI.rule.event?.name}}</td>
					<td>
						<label *ngIf="ruleUI.rule.isActive" (click)="deactivateRule(ruleUI.rule)"
							class="btn btn-primary">YES</label>
						<label *ngIf="!ruleUI.rule.isActive" (click)="activateRule(ruleUI.rule)"
							class="btn btn-default">NO</label>
					</td>
					<td>
						<ng-container *ngIf="ruleUI.rule.groups != null && ruleUI.rule.groups.length > 0">
							<ng-container *ngFor="let group of ruleUI.rule.groups">
								<button class="groupButton">{{group.name}}</button>
							</ng-container>
						</ng-container>
					</td>
					<td><button class="btn btn-ef" (click)="deleteRule(ruleUI.rule)">DELETE</button></td>
				</tr>
			</ng-container>
		</tbody>
	</table>

	<pagination-controls class="pagination" id="rule_pagination" (pageChange)="pageChanged($event)"
		[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
	</pagination-controls>

	</div>
</div>

<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeFromGroup($event)">
</app-remove-from-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>